import { FC, useEffect, useState } from "react";
import Modal from "react-modal";
import close from "assets/images/close.svg";
import Imgclose from "assets/images/input-img-close-icon.svg";
import Button from "components/particles/primary-button";

import { Container, StyledReactModal } from "./style";
import img from "assets/images/input-img-icon.svg";
import { useForm } from "react-hook-form";
import FormErrorMessage from "components/particles/forms/form-error-message";
import placeHolder from "assets/images/placeholder.jpg";

import { dispatch } from "store";
import { setModalClosed } from "store/user-slice";
import { useSelector } from "react-redux";
import { useIngredient } from "containers/Ingredients/useHook";
import { IngredientDTO } from "utils/helpers/models/ingredients.dto";

interface AddCategoryModelProps {
  id: number;
  data: any;
  onSuccess: () => void;
}

const AddIngredientModal: FC<AddCategoryModelProps> = ({ id, data, onSuccess }) => {
  console.log(id, "id");

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm<IngredientDTO>();
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  // FIX 2: Add state to track if image should be removed
  const [shouldRemoveImage, setShouldRemoveImage] = useState<boolean>(false);
  const { postIngredient, putIngredient } = useIngredient();
  const { addIngredientModalIsOpen } = useSelector((state: any) => state.user);

  console.log(selectedImage);
  

  const handleImageChange = (event: any) => {
    setSelectedImage(URL.createObjectURL(event?.target?.files[0]));
    setValue("image", event.target.files[0]);
    // FIX 2: Reset remove flag when new image is selected
    setShouldRemoveImage(false);
  };

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      fontSize: "2rem",
      width: "68.5rem",
      borderRadius: "3rem",
    },
  };

  function closeModal() {
    // FIX 2: Reset states when modal closes
    setSelectedImage(null);
    setShouldRemoveImage(false);
    dispatch(setModalClosed("Ingredient"));
  }

  useEffect(() => {
    if (data) {
      // FIX 2: Reset remove flag when new data is loaded
      setShouldRemoveImage(false);
      for (let key in new IngredientDTO()) {
        if (data[key] !== undefined) {
          if ((key as keyof IngredientDTO) === "image") {
            setSelectedImage(data[key]);
          } else {
            setValue(key as keyof IngredientDTO, data[key]);
          }
        }
      }
    }
  }, [data]);

  // FIX 2: Enhanced onSubmit to handle image removal
  const onSubmit = async (formDataValues: IngredientDTO) => {
    const formData = new FormData();

    if (id !== 0) {
      // Update existing ingredient
      if (shouldRemoveImage) {
        // FIX 2: Send empty string or null to remove image
        formData.append("image", "null"); // or use "removeImage", "true" based on your API
      } else if (getValues("image") instanceof File) {
        // New image selected
        formData.append("image", getValues("image"));
      }
      // If neither shouldRemoveImage nor new file, don't append image (keep existing)
      
      await putIngredient(id, formData);
      await onSuccess();
      closeModal();
    } else {
      // Add new ingredient
      for (let key in getValues()) {
        if (key === "image") continue;
        const val = getValues(key as keyof IngredientDTO);
        formData.append(key, val);
      }
      
      // Only append image if one is selected
      if (getValues("image") instanceof File) {
        formData.append("image", getValues("image"));
      }
      
      await postIngredient(formData);
      await onSuccess();
      closeModal();
    }
  };

  // FIX 2: Enhanced closeImg function
  function closeImg() {
    setSelectedImage(null);
    setValue("image", null);
    // FIX 2: Mark that image should be removed for existing ingredients
    if (id !== 0) {
      setShouldRemoveImage(true);
    }
  }

  return (
    <StyledReactModal
      isOpen={addIngredientModalIsOpen}
      onRequestClose={closeModal}
      contentLabel="Example Modal"
    >
      <Container onSubmit={handleSubmit(onSubmit)}>
        <div className="close-button" onClick={closeModal}>
          <img src={close} style={{ cursor: "pointer" }} alt="img" />
        </div>
        <div className="model-container">
          <div
            className="popup-title"
            style={{ width: "100%", textAlign: "center", marginTop: "4rem" }}
          >
            <h1>{id === 0 ? "Add Ingredients" : "Update Ingredients"}</h1>
          </div>
          <div className="add-ingredient-container">
            <div className="image-container">
              <div className="image-input-wrapper">
                {selectedImage && !shouldRemoveImage ? (
                  <>
                    <img
                      className="uploaded-image"
                      src={selectedImage || placeHolder}
                      alt="Selected"
                    />
                    <img
                      className="close-icon"
                      src={Imgclose}
                      alt="Remove"
                      onClick={closeImg}
                    />
                  </>
                ) : (
                  <>
                    <label htmlFor="image-input">
                      <img src={img} alt="Upload" />
                    </label>
                    <input
                      id="image-input"
                      type="file"
                      accept="image/*"
                      className="hidden-input"
                      {...register("image")}
                      onChange={handleImageChange}
                    />
                  </>
                )}
              </div>
              <p>{getValues("image.name")}</p>
            </div>
            {!id && (
              <>
                <div>
                  <input
                    type="text"
                    placeholder="Ingredient Name"
                    {...register("name", { required: true })}
                  />
                  <FormErrorMessage error={errors.name} />
                </div>
                <select
                  id="Status"
                  {...register("status")}
                  required
                >
                  <option>status</option>
                  <option value="true">Active</option>
                  <option value="false">Inactive</option>
                </select>
              </>
            )}
          </div>
          <div className="add-button">
            <Button
              title={id === 0 ? "Add" : "Update"}
              width="51.2rem"
              backgroundcolor="var(--primary)"
              fill="true"
                disabled={!selectedImage}
            />
          </div>
        </div>
      </Container>
    </StyledReactModal>
  );
};

export default AddIngredientModal;